import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
import store from "./../store";
import { DetectBrand } from "../mixins/brandDetector";
import { AppConfig } from "../../AppConfig";
import { isProduction } from "../api/payment/Utilities";
var brandedConfig = {
  apiKey: "AIzaSyDDAfrPKcVxx096l5SHZvoaWt7d-wrag-8",
  authDomain: "abacus-online-ordering-test.firebaseapp.com",
  databaseURL: "https://abacus-online-ordering-test.firebaseio.com",
  projectId: "abacus-online-ordering-test",
  storageBucket: "abacus-online-ordering-test.appspot.com",
  messagingSenderId: "1087170880950",
};
var generalConfig = {
  apiKey: "AIzaSyAMhuFsddO482nDpQp-jr6tUwyw-mjG6Us",
  authDomain: "abacus-company-project.firebaseapp.com",
  databaseURL: "https://abacus-company-project.firebaseio.com",
  projectId: "abacus-company-project",
  storageBucket: "abacus-company-project.appspot.com",
  messagingSenderId: "799769146157",
  appId: "1:799769146157:web:d497b21a3e793a5c",
};
var releaseConfig = {
  apiKey: AppConfig.firebaseApiKey,
  authDomain: AppConfig.firebaseProjectId + ".firebaseapp.com",
  databaseURL: AppConfig.firebaseProjectId + ".firebaseio.com",
  projectId: AppConfig.firebaseProjectId,
  storageBucket: AppConfig.firebaseProjectId + ".appspot.com",
  messagingSenderId: AppConfig.firebaseMessagingSenderId,
};
const app = firebase.initializeApp(
  process.env.NODE_ENV === "production"
    ? releaseConfig
    : DetectBrand.methods.isBranded()
    ? brandedConfig
    : generalConfig
);

/*
  setLogLevel param:
- debug for the most verbose logging level, primarily for debugging.
- error to log errors only.
- silent to turn off logging.
*/
firebase.firestore.setLogLevel("silent");
if (!isProduction()) {
  //firebase.auth().settings.appVerificationDisabledForTesting = true;
}
export const db = app.firestore();
export const auth = app.auth();
export const rtdb = app.database();
export const cloudDB = app.database(
  AppConfig.databaseURL
    ? AppConfig.databaseURL
    : `https://${AppConfig.firebaseProjectId}-test.firebaseio.com`
);
auth.onAuthStateChanged(async (user) => {
  if (user) {
    store.dispatch("autoSignIn", user);
  } else {
    store.commit("setUser", null);
    store.commit("setDBUser", null);
  }
});
